var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('BaseFrame',{attrs:{"breadcrumb":[
      {
        name: 'maintainPlanList',
        title: '养护/检定计划列表'
      },
      {
        name: 'maintainPlanMeasure',
        title: '计量器具检定结果维护'
      }
    ],"btns":[
      {
        name: 'cancel',
        text: '取消',
      },
      {
        name: 'save',
        text: '保存',
        type: 'primary'
      },
      {
        name: 'submit',
        text: '提交',
        type: 'primary'
      }
    ]},on:{"btn-click":_vm.onBtnClick}},[_c('div',{attrs:{"slot":"info"},slot:"info"},[_c('div',[_vm._v("计划编号："+_vm._s(_vm.assertsCuringPlan.code))]),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"info-item"},[_vm._v("门店名称："+_vm._s(_vm.assertsCuringPlan.storeName))]),_c('div',{staticClass:"info-item"},[_vm._v("创建时间："+_vm._s(_vm.assertsCuringPlan.createTime))]),_c('div',{staticClass:"info-item"},[_vm._v("创建人："+_vm._s(_vm.assertsCuringPlan.createUserName))]),_c('div',{staticClass:"info-item"},[_vm._v("计划状态："+_vm._s(_vm.assertsCuringPlan.statusStr))]),_c('div',{staticClass:"info-item"},[_vm._v("设备类型："+_vm._s(_vm.assertsCuringPlan.typeStr))])])]),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('lk-card',{attrs:{"title":"录入养护结果"}},[_c('lk-table',{staticClass:"plan-table requireAssetAdd",attrs:{"border":"","columns":_vm.columns,"data":_vm.assertsCuringHistoryVOs}})],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }